<template>
  <div class="posts-wrapper">
    <div class="packages">
      <div
        :class="['wrap-boxes', { 'wrap-opacity': boxActive != null }]"
        v-if="userInfoData.role == Roles.Admin"
      >
        <template v-for="(stat, index) in packageStats">
          <div
            :class="['box st-' + stat.code, { active: boxActive == stat.code }]"
            @click="filterPackages(stat.code)"
            :key="index"
          >
            <span>{{ stat.total }}</span>
            <p>{{ stat.name }}</p>
          </div>
        </template>
      </div>
      <div class="filters">
        <div class="title">Búsqueda</div>
        <div class="wrap-filter">
          <div class="item">
            <vs-input label="Nombre o Nro tracking" v-model="keyword" />
          </div>
          <div class="item">
            <label for="">Fechas</label>
            <v-date-picker
              mode="range"
              v-model="dateFilter"
              locale="es"
              :popover="{ placement: 'top', visibility: 'click' }"
            ></v-date-picker>
          </div>
          <div class="item" v-if="userInfoData.role == Roles.Admin">
            <vs-select
              autocomplete
              label="Filtro Colores"
              v-model="colorSelected"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.name"
                v-for="(item, index) in statusColors"
              />
            </vs-select>
          </div>
          <div class="item" v-if="userInfoData.role == Roles.Admin">
            <vs-select
              autocomplete
              multiple
              label="Filtro Letras"
              class="letters"
              v-model="lettersSelected"
            >
              <vs-select-item
                :key="index"
                :value="item"
                :text="item"
                v-for="(item, index) in letters"
              />
            </vs-select>
          </div>
          <div class="item btnFilter">
            <vs-button
              id="btnFilter"
              class="vs-con-loading__container"
              color="primary"
              type="border"
              icon="search"
              @click="searchPackages()"
              >Filtrar paquetes</vs-button
            >
            <vs-button
              color="success"
              to="/packages/updateStatus"
              type="border"
              icon="refresh"
              class="ml-10"
              v-if="userInfoData.role == Roles.Admin"
              >Track Packs</vs-button
            >
          </div>
        </div>
      </div>
      <div class="box-white-wrapper" v-if="packages.length > 0">
        <vs-table
          :data="tempPackges"
          pagination
          max-items="50"
          :key="keyPackages"
        >
          <template
            slot="header"
            v-if="userInfoData.role == Roles.Distribuitor"
          >
            <div class="extra-actions">
              <vs-button
                color="primary"
                type="border"
                icon="cached"
                @click="openModalSurveyBulk()"
                v-if="updateMultiplePacks.length > 0"
                >Confirmar entrega ({{ updateMultiplePacks.length }})</vs-button
              >
            </div>
          </template>
          <template
            slot="header"
            v-if="userInfoData.role != Roles.Distribuitor"
          >
            <vs-button
              class="pkgPreAlert"
              color="primary"
              to="/pre-alert"
              type="border"
              icon="library_add"
              >Pre Alertar Paquete</vs-button
            >
            <div class="extra-actions" v-if="userInfoData.role == Roles.Admin">
              <vs-button
                color="primary"
                type="border"
                icon="cached"
                @click="changePackageStatus('', 'multiple')"
                v-if="updateMultiplePacks.length > 0"
                >Actualizar Estado</vs-button
              >
              <vs-button
                id="btnDownloadPacks"
                class="vs-con-loading__container"
                @click="downloadPackagesReport"
                color="primary"
                type="border"
                icon="cloud_download"
                >Descargar</vs-button
              >
              <vs-button
                color="primary"
                type="border"
                icon="send"
                @click="activeSendReport = true"
                v-if="updateMultiplePacks.length > 0"
                >Enviar</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <!-- <vs-th
              sort-key="id"
              class="width-30"
              v-if="userInfoData.role == Roles.Admin"
            ></vs-th> -->
            <th>
              <vs-checkbox class="packages-checkbox-selectall"
                color="#1a426d"
                v-model="selectAll"
                @change="toggleSelectAll"
              ></vs-checkbox>
            </th>
            <!-- <vs-th sort-key="id" v-if="userInfoData.role == Roles.Admin"
              >#</vs-th
            > -->
            <vs-th sort-key="barcode">Barcode</vs-th>
            <vs-th sort-key="tracking">Tracking</vs-th>
            <vs-th sort-key="firstName">Nombre </vs-th>
            <vs-th sort-key="email">Email </vs-th>
            <vs-th sort-key="createdAt"> Fecha Registro </vs-th>
            <vs-th sort-key="statusname"> Estado </vs-th>
            <vs-th sort-key="id" class="width-30"></vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td
                class="switchMultiplePacks"
                v-if="userInfoData.role == Roles.Admin || userInfoData.role == Roles.Distribuitor"
              >
                <vs-checkbox
                  color="#1a426d"
                  v-model="updateMultiplePacks"
                  :vs-value="data[indextr].id"
                ></vs-checkbox>
              </vs-td>
              <!-- <vs-td
                :data="data[indextr].id"
                class="nopl"
                v-if="userInfoData.role == Roles.Admin"
                >{{ data[indextr].id }}</vs-td
              > -->
              <vs-td :data="data[indextr].barcode">
                <span v-if="data[indextr].id">{{ data[indextr].id }}</span>
                <span v-else>No disponible</span>
              </vs-td>
              <vs-td :data="data[indextr].tracking" class="nopl">
                <div class="d-flex">
                  <div
                    class="circle st-warning"
                    v-if="data[indextr].permission == 1"
                  ></div>
                  <div
                    class="circle status-2"
                    v-if="data[indextr].prealerted == 1"
                  ></div>
                  <div
                    class="circle danger"
                    v-if="data[indextr].followUp == 1"
                  ></div>
                  <div
                    class="circle success"
                    v-if="data[indextr].userAdjust == 1"
                  ></div>
                  {{ data[indextr].tracking }}
                </div>
              </vs-td>
              <vs-td :data="data[indextr].firstName">
                {{ data[indextr].firstName + " " + data[indextr].lastName }}
              </vs-td>
              <vs-td :data="data[indextr].email">
                <a :href="`mailto:${data[indextr].email}`">{{
                  data[indextr].email
                }}</a>
              </vs-td>
              <vs-td :data="data[indextr].createdAt">
                {{ data[indextr].createdAt | moment("DD/MM/YYYY") }}
              </vs-td>
              <vs-td :data="data[indextr].statuscode">
                <span
                  :class="`status status-${data[indextr].statuscode}`"
                  @click="changePackageStatus(data[indextr], 'single')"
                >
                  {{ data[indextr].displayName }}
                </span>
              </vs-td>
              <vs-td :data="data[indextr].id">
                <div
                  class="table-actions"
                  v-if="userInfoData.role != Roles.Distribuitor"
                >
                  <router-link :to="`/package/${data[indextr].id}`"
                    ><feather type="eye"
                  /></router-link>
                  <a
                    href="javascript:void(0)"
                    @click="openModalSurvey(data[indextr])"
                    v-if="userInfoData.role == Roles.Admin || userInfoData.role == Roles.Distribuitor"
                  >
                    <feather type="clipboard" />
                  </a>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>

      <modalPackage
        @modal-event="handleActionModalPackage"
        :packIDs="updateMultiplePacks"
        :packID="packageId"
        :modeUdpdate="typeChangeSt"
        :selected="pkgCurrentStatus"
        :show="modalActive"
      ></modalPackage>

      <modal-survey
        @modal-event="handleActionModalSurvey"
        :packID="packageId"
        :packIDs="packIDsSurvey"
        :customer="customerId"
        :show="modalActiveSurvey"
      ></modal-survey>

      <vs-prompt
        title="Envió de datos"
        color=""
        accept-text="Enviar"
        cancel-text="Cancelar"
        @accept="confirmToSent"
        @close="closedModaSendReport()"
        @cancel="closedModaSendReport()"
        :active="activeSendReport"
        :buttons-hidden="buttonsHidden"
      >
        <div class="recovery form">
          <div class="form-input">
            <vs-input label="Correo Electrónico" v-model="sendEmail" />
          </div>
          <div class="form-input">
            <vs-input label="Cc." v-model="sendCC" />
            <br v-if="buttonsHidden" />
            <p v-if="buttonsHidden">Procesando.. Espero un momento</p>
          </div>
        </div>
      </vs-prompt>
    </div>
    <displayInformation
      v-if="packages.length < 1"
      message="No se han encontrado paquetes registrados."
      :showButton="true"
    ></displayInformation>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { helper } from "@/helpers/utils";
import { Role } from "@/helpers/Role.js";
import PackageModel from "@/models/PackageModel";
import { required } from "vuelidate/lib/validators";
import PackageDataService from "@/services/PackageDataService";
import ModalPackage from "@/components/Modal/PackageStatus.vue";
import ModalSurvey from "@/components/Modal/UserSurvey.vue";
import DisplayInformation from "@/components/DisplayInformation.vue";
export default {
  name: "Packages",
  mixins: [helper],
  components: {
    ModalPackage,
    ModalSurvey,
    DisplayInformation,
  },
  data() {
    return {
      keyPackages: 0,
      noLimit: false,
      typeChangeSt: false,
      updateMultiplePacks: [],
      selectAll: false, 
      sendEmail: "",
      sendCC: "",
      buttonsHidden: false,
      activeSendReport: false,
      packageId: "",
      dateFilter: "",
      pkgCurrentStatus: { id: 2, name: "PreAlerta" },
      modalActive: false,
      confirmStatus: false,
      searchkeyword: "",
      message: "",
      postId: 0,
      page: 1,
      countPost: 0,
      packageStats: [],
      packID: '',
      newStatus: {},
      package: new PackageModel(),
      packages: [],
      tempPackges: [],
      Roles: [],
      boxActive: null,
      keyword: "",
      filterObj: {
        dateFilter: null,
        status: null,
        filter: "",
      },
      colorSelected: "",
      statusColors: [
        {
          value: 0,
          name: "Ninguno",
        },
        {
          value: 1,
          name: "Pre Alertado (Azul)",
        },
        {
          value: 2,
          name: "Paquete incompleto (Rojo)",
        },
        {
          value: 3,
          name: "Cliente Actualizo Paquete (Verde)",
        },
        {
          value: 4,
          name: "Permiso Adicional (Naranja)",
        },
      ],
      lettersSelected: "",
      letters: [
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "ñ",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
      ],
      customerId: "",
      packIDsSurvey: [],
      modalActiveSurvey: false,
    };
  },
  created() {
    this.Roles = Role;
  },
  computed: {
    ...mapState(["userInfoData"]),
  },
  beforeMount() {
    this.$Progress.start();
  },
  mounted() {
    this.getPackagesStats();
    this.retrievePackages();
  },
  validations: {
    package: {
      status: { required },
    },
  },
  methods: {
    handleActionModalSurvey(response) {
      if (response.error != undefined) {
        if (!response.error) {
          let _ids = this.packIDsSurvey.length > 0 ? this.packIDsSurvey : [this.packageId];
          _ids.forEach((id) => {
            let pos = this.tempPackges.findIndex((item) => item.id == id);
            if (pos > -1) {
              this.tempPackges.splice(pos, 1);
            }
          });
          this.updateMultiplePacks = [];
          this.$vs.notify({
            title: "Información!",
            text: _ids.length > 1 ? "Los paquetes fueron entregados exitosamente!" : "El paquete fue entregado con exitosamente!",
            color: "success",
            icon: "check",
          });
        } else {
          this.$vs.notify({
            title: "Información!",
            text: "Error actualizando el estado del paquete",
            color: "danger",
            icon: "error_outline",
          });
        }
      }
      this.modalActiveSurvey = response.active;
      if (!response.active) this.packIDsSurvey = [];
    },
    openModalSurvey(pack) {
      this.packageId = pack.id;
      this.customerId = pack.cu01Id;
      this.packIDsSurvey = [];
      this.modalActiveSurvey = true;
    },
    openModalSurveyBulk() {
      if (this.updateMultiplePacks.length === 0) return;
      let _custIds = [
        ...new Set(
          this.updateMultiplePacks.map((id) => {
            let _objPack = this.tempPackges.find((item) => item.id === id);
            return _objPack ? _objPack.cu01Id : null;
          })
        ),
      ];
      if (_custIds.length > 1 || _custIds.some((id) => id == null)) {
        this.$vs.notify({
          title: "Información!",
          text: "Selecciona paquetes de un mismo cliente para procesarlos juntos.",
          color: "warning",
          icon: "error_outline",
        });
        return;
      }
      this.packageId = String(this.updateMultiplePacks[0]);
      this.customerId = _custIds[0];
      this.packIDsSurvey = [...this.updateMultiplePacks];
      this.modalActiveSurvey = true;
    },
    toggleSelectAll() {
      if (this.selectAll) {
        // Seleccionar todos: Agregar todos los IDs a updateMultiplePacks
        this.updateMultiplePacks = this.tempPackges.map(pack => pack.id);
      } else {
        // Deseleccionar todos: Vaciar la lista de seleccionados
        this.updateMultiplePacks = [];
      }
    },
    isAllSelected() {
      // Comprobar si todos los paquetes están seleccionados
      return this.updateMultiplePacks.length === this.tempPackges.length;
    },
    handleActionModalPackage(response) {
      if (response.error != undefined) {
        if (!response.error) {
          this.retrievePackages();
          this.getPackagesStats();
          this.updateMultiplePacks = [];
          this.$vs.notify({
            title: "Información!",
            text: "El estado del paquete fue modificado exitosamente!",
            color: "success",
            icon: "check",
          });
        } else {
          this.$vs.notify({
            title: "Información!",
            text: "Error actualizando el estado del paquete",
            color: "danger",
            icon: "error_outline",
          });
        }
      }
      this.modalActive = response.active;
    },
    changePackageStatus(pack, type) {
      if (this.userInfoData.role == this.Roles.Admin) {
        this.packageId = pack.id;
        this.customerId = pack.cu01Id;
        this.typeChangeSt = type != "single" ? true : false;
        type != "single" ? true : false;
        if (type == "single") {
          this.pkgCurrentStatus = this.currentPackStatus(pack.id);
        }
        this.modalActive = true;
      } else if (this.userInfoData.role == this.Roles.Distribuitor) {
        this.openModalSurvey(pack);
      }
    },
    currentPackStatus(id) {
      let _objPack = this.packages.filter((item) => {
        return id === item.id;
      });
      _objPack = _objPack[0];
      let newStatus = { id: _objPack.statuscode, name: _objPack.statusname };
      return newStatus;
    },
    retrievePackages() {
      let _dateFilter =
        this.dateFilter != "" && this.dateFilter != null
          ? this.dateFilter
          : null;
      this.filterObj.dateFilter =
        _dateFilter != null
          ? {
              end: this.$moment(this.dateFilter.end).format("YYYY/MM/DD"),
              start: this.$moment(this.dateFilter.start).format("YYYY/MM/DD"),
            }
          : null;

      this.filterObj.status = this.boxActive;
      this.filterObj.filter = this.keyword;
      this.filterObj.letters = this.lettersSelected;
      this.filterObj.color = this.colorSelected;

      if (!this.noLimit) {
        this.filterObj.limit = 400;
      }

      this.loadingProgress("#btnFilter", "#1a426d");
      PackageDataService.getAll(this.filterObj)
        .then((response) => {
          this.packages = response.data;
          this.tempPackges = this.packages;
          this.$Progress.finish();
          this.$vs.loading.close(".vs-con-loading__container .con-vs-loading");
          this.noLimit = false;
          this.keyPackages++;
        })
        .catch((e) => {
          console.log(e);
          this.$Progress.finish();
          this.$vs.loading.close(".vs-con-loading__container .con-vs-loading");
          this.$vs.notify({
            title: "Error!",
            text: "Error obteniendo los paquetes!",
            color: "danger",
            icon: "error_outline",
          });
        });
    },
    getPackagesStats() {
      PackageDataService.getPackStats()
        .then((response) => {
          this.packageStats = response.data;
        })
        .catch((e) => {
          console.log(e);
          this.$vs.notify({
            title: "Error!",
            text: "Error obteniendo las estadisticas de los clientes!",
            color: "danger",
            icon: "error_outline",
          });
        });
    },
    searchPackages() {
      this.noLimit = true;
      this.retrievePackages();
    },
    filterPackages(index) {
      this.selectAll = false,
      this.updateMultiplePacks = [],
      this.noLimit = true;
      this.boxActive != index
        ? (this.boxActive = index)
        : (this.boxActive = null);
      this.retrievePackages();
    },
    closedModaSendReport() {
      this.activeSendReport = false;
      this.buttonsHidden = false;
      this.sendEmail = "";
      this.sendCC = "";
    },
    confirmToSent() {
      const that = this;
      that.buttonsHidden = true;
      let _dateFilter =
        this.dateFilter != "" && this.dateFilter != null
          ? this.dateFilter
          : null;
      this.filterObj.dateFilter =
        _dateFilter != null
          ? {
              end: this.$moment(this.dateFilter.end).format("YYYY/MM/DD"),
              start: this.$moment(this.dateFilter.start).format("YYYY/MM/DD"),
            }
          : null;
      this.filterObj.status = this.boxActive;
      this.filterObj.filter = this.keyword;
      this.filterObj.emailreport = this.sendEmail;
      this.filterObj.emailcopy = this.sendCC;
      this.filterObj.ids = this.updateMultiplePacks;
      this.filterObj.letters = this.lettersSelected;
      this.filterObj.color = this.colorSelected;
      PackageDataService.sendReportByEmail(this.filterObj)
        .then(() => {
          that.activeSendReport = false;
          that.buttonsHidden = false;
          that.sendEmail = "";
          that.sendCC = "";
          that.$vs.loading.close("#btnDownloadPacks .con-vs-loading");
          that.updateMultiplePacks = [];
          that.retrievePackages();
          that.$vs.notify({
            title: "Información!",
            text: "El documento fue enviado exitosamente!",
            color: "success",
            icon: "check",
          });
        })
        .catch((e) => {
          console.log(e);
          that.buttonsHidden = false;
          that.$vs.notify({
            title: "Información!",
            text: "Error enviado el documento!",
            color: "danger",
            icon: "error_outline",
          });
        });
    },
    downloadPackagesReport() {
      const that = this;
      that.loadingProgress("#btnDownloadPacks", "#1f74ff");
      that.confirmStatus = true;
      let _dateFilter =
        this.dateFilter != "" && this.dateFilter != null
          ? this.dateFilter
          : null;
      this.filterObj.dateFilter =
        _dateFilter != null
          ? {
              end: this.$moment(this.dateFilter.end).format("YYYY/MM/DD"),
              start: this.$moment(this.dateFilter.start).format("YYYY/MM/DD"),
            }
          : null;
      this.filterObj.status = this.boxActive;
      this.filterObj.filter = this.keyword;
      this.filterObj.letters = this.lettersSelected;
      this.filterObj.color = this.colorSelected;

      PackageDataService.downloadPackages(this.filterObj)
        .then((response) => {
          console.log(response.data);
          that.confirmStatus = false;
          let blob = new Blob([response.data], {
            type: "application/vnd.ms-excel",
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = "Packages.xlsx";
          a.click();
          window.URL.revokeObjectURL(url);
          that.$vs.loading.close("#btnDownloadPacks .con-vs-loading");
          that.$vs.notify({
            title: "Información!",
            text: "La descarga de los paquetes ha iniciado!",
            color: "success",
            icon: "check",
          });
        })
        .catch((e) => {
          console.log(e);
          that.$vs.loading.close(".vs-con-loading__container .con-vs-loading");
          that.confirmStatus = false;
          that.$vs.notify({
            title: "Información!",
            text: "Error descargado los paquetes!",
            color: "danger",
            icon: "error_outline",
          });
        });
    },
  },
  watch: {
    // Monitorea si todos los checkboxes están seleccionados y sincroniza el estado de 'selectAll'
    updateMultiplePacks() {
      this.selectAll = this.isAllSelected();
    }
  }
};
</script>
